
import './index.scss';

import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { BookingStep } from '../../constants';
import { getPartnerInfo } from '../../utils/bookingUtil';
import { Spinner } from '../Suspense';
import { Configuration } from '../../types/configuration';
import { salonActions } from '../../actions/salon';
import config from '../../utils/config';
import BookingUsers from '../BookingUsers';
import BookingDetail from '../BookingDetail';
import BookingConfirmation from '../BookingConfirmation';

interface Props {
  step: number;
  salonId: number;
  standalone: boolean;
  redirectUrl: string;
  canCancel: boolean;
  withContainer: boolean;
  bookingSettings: Configuration;
  storeBookingSettings: (options: any) => void;
  isLoading?: boolean;
}

class Booking extends React.PureComponent<Props> {
  private attachStripePublicKey() {
    const windowStripe = (window as any).Stripe;
    if (windowStripe) {
      windowStripe.setPublishableKey(config.stripeApikey);
    }
  }

  cancelBooking() {
    const { redirectUrl } = this.props;
    if (redirectUrl) {
      const targetWindow = window.parent || window;
      if (targetWindow) {
        targetWindow.location.href = redirectUrl;
      }
    }
  }

  componentDidMount() {
    const { bookingSettings, storeBookingSettings } = this.props;

    // store booking settings in redux store
    if (bookingSettings) {
      storeBookingSettings(bookingSettings);
    }

    // set Stripe public key
    this.attachStripePublicKey();
  }

  render() {
    const { step, bookingSettings } = this.props;

    if (!step || !bookingSettings) {
      return <Spinner />;
    }

    const { salonId, withContainer, standalone, canCancel, redirectUrl } = this.props;
    const partner = getPartnerInfo(salonId);

    return (
      <div className={canCancel && !!redirectUrl ? 'fave-layout--with-cancel' : ''}>
        {canCancel && !!redirectUrl && (
          <Button
            className="btn--cancel-booking"
            type="primary"
            shape="circle"
            icon={<CloseOutlined />}
            onClick={() => this.cancelBooking()}
          />
        )}

        <div className={withContainer || (partner && standalone) ? 'fave-layout--container' : ''}>
          {step === BookingStep.Users && (
            <BookingUsers />
          )}

          {step === BookingStep.BookingDetail && (
            <BookingDetail />
          )}

          {step === BookingStep.Confirmation && (
            <BookingConfirmation />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  step: state.bookingStore.step,
  canCancel: state.salonStore.canCancel,
  redirectUrl: state.salonStore.redirectUrl,
  salonId: state.salonStore.salonId,
  standalone: state.salonStore.standalone,
  withContainer: state.salonStore.withContainer,
});
const mapDispatchToProps = dispatch => ({
  storeBookingSettings: (options) => dispatch(salonActions.storeBookingSettings(options)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Booking);
